
import { useEffect } from 'react'

interface FlexibleOptions {
  designWidth?: number
}

export const useFlexible = ({ designWidth = 375 }: FlexibleOptions = {}) => {
  const changeSize = () => {
    document.documentElement.style.fontSize = (document.documentElement.clientWidth * 12) / designWidth + 'px'
  }

  useEffect(() => {
    changeSize()

    window.addEventListener('resize', changeSize, false)
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        changeSize()
      }
    })

    return () => {
      window.removeEventListener('resize', changeSize)
      window.removeEventListener('pageshow', changeSize) 
    }
  }, [designWidth])
}
